import Vue from 'vue';
import App from './App.vue';
import router from './router';
import axios from 'axios';

Vue.config.productionTip = false;

Vue.prototype.axios = window.axios = axios;

axios.defaults.baseURL = 'http://tele2.roscontent.ru/';
Vue.prototype.$hostname = 'http://tele2.roscontent.ru/';

window.events = new Vue();

window.getTimeZoneNum = function () {
	var offset = new Date().getTimezoneOffset(), o = Math.abs(offset);
	return parseInt((offset < 0 ? "+" : "-") + ("" + Math.floor(o / 60)).slice(-2));
};

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
